import { CreditCardIcon, NewspaperIcon } from "@heroicons/react/24/solid";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import ExpenseAccount from "./ExpenseAccount";
import Autopay from "./Autopay";
export const VendorConfigTabs = [
  {
    to: ROUTE_PATHS.Utilities_VendorConfiguration_Autopay_Index,
    icon: <CreditCardIcon className="h-4 w-4 float-left mr-2 " />,
    title: "AutoPay",
    component: Autopay,
    permission: PERMISSIONS.permission_utilities_autopay_view,
  },
  {
    to: ROUTE_PATHS.Utilities_VendorConfiguration_ExpenseAccount_Index,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Expense Account",
    component: ExpenseAccount,
    permission: PERMISSIONS.permission_utilities_expenseaccount_view,
  },
];
